import { render, staticRenderFns } from "./slider-photo.vue?vue&type=template&id=4fd03565"
import script from "./slider-photo.vue?vue&type=script&lang=js"
export * from "./slider-photo.vue?vue&type=script&lang=js"
import style0 from "./slider-photo.vue?vue&type=style&index=0&id=4fd03565&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports